import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { Language } from '../models/language';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  /** Match files under assets/i18n/*.json to avoid failed translation loads. */
  public languages: string[] = ['en', 'fr', 'pl'];
  private backUrl = environment.backUrl;

  constructor(public translate: TranslateService, 
    private cookieService: CookieService,
    private http: HttpClient) {
    let browserLang;
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      this.setLanguage('en');
      browserLang = translate.getBrowserLang();
    }
    translate.use(browserLang.match(/en|fr|pl/) ? browserLang : 'en');
  }

  public setLanguage(lang) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
  }

  getLanguages() {
    return this.http.get<Language[]>(this.backUrl + "/languages" );
  }

}
